import module from 'recursoshumanos/module.js'
import template from './template.html'
import { orderBy } from 'lodash'

const diacriticosRegex = /[\u0300-\u036f]/g
const normalizar = (valor) => valor.normalize('NFD').replace(diacriticosRegex, '').toUpperCase()

export class RecursoshumanosComparativasuanominaListaComponent {
  empresaId
  periodo
  mes
  data
  filtro = ``
  resultados = []
  exportando = false

  $onChanges (changes) {
    if (changes.data) {
      let data = this.data.map((item) => {
        const busqueda = normalizar(`${item.colaborador}|${item.nss}`)
        const suaExiste = item.sua !== null
        const nominaExiste = item.nomina !== null
        const totalCoincide = suaExiste && nominaExiste && Math.trunc(item.sua.total) === Math.trunc(item.nomina.total)
        const valido = suaExiste && nominaExiste && totalCoincide

        return {...item, busqueda, totalCoincide, suaExiste, nominaExiste, valido}
      })
      this.data = orderBy(data, ['valido', 'colaborador'], ['asc', 'asc'])
      this.validos = this.data.filter((item) => item.valido).length
      this.invalidos = this.data.length - this.validos
      this.filtrar()
    }
  }

  filtrar () {
    if (this.filtro === '') {
      this.resultados = [...this.data]
    } else {
      let filtro = normalizar(this.filtro)
      this.resultados = this.data.filter((item) => item.busqueda.indexOf(filtro) >= 0)
    }
  }
}

module.component('recursoshumanosComparativasuanominaLista', {
  controller: RecursoshumanosComparativasuanominaListaComponent,
  template,
  bindings: {
    empresaId: '<',
    periodo: '<',
    mes: '<',
    data: '<',
  },
})



// WEBPACK FOOTER //
// ./src/recursoshumanos/components/comparativaSuaNomina/lista/component.js